/**
 * PEPAX Product Page JavaScript
 * Handles: variant switching, image gallery, quantity selector,
 *          add-to-cart AJAX, accordion, sticky bar visibility
 */

(function() {
  'use strict';

  const productPage = document.querySelector('.pepax-product-page');
  if (!productPage) return;

  // ─────────────────────────────────────────
  // 1. Variant Selector
  // ─────────────────────────────────────────
  const variantSelect = document.getElementById('variant-select');
  const mainImage = document.getElementById('product-main-image');
  const regularPriceEls = document.querySelectorAll('[data-regular-price]');
  const subscribePriceEls = document.querySelectorAll('[data-subscribe-price]');
  const addToCartBtns = document.querySelectorAll('[data-add-to-cart]');
  const btnTexts = document.querySelectorAll('.btn-text');
  const sellingPlanInputs = document.querySelectorAll('[name="selling_plan"]');

  function formatMoney(cents) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: (Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
    return formatter.format(cents / 100);
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const price = parseInt(selectedOption.getAttribute('data-price'), 10);
      const imageUrl = selectedOption.getAttribute('data-image');

      // Update price displays
      regularPriceEls.forEach(function(el) {
        el.textContent = formatMoney(price);
      });

      const subscribePrice = Math.round(price * 0.85);
      subscribePriceEls.forEach(function(el) {
        el.textContent = formatMoney(subscribePrice) + '/mo';
      });

      // Update add to cart buttons
      addToCartBtns.forEach(function(btn) {
        btn.setAttribute('data-variant-id', this.value);
      }.bind(this));

      // Update button text with quantity
      const qtyInputEl = document.querySelector('[data-quantity-input]');
      const qty = parseInt(qtyInputEl ? qtyInputEl.value : 1, 10);
      btnTexts.forEach(function(el) {
        el.textContent = 'Add to Cart \u2014 ' + formatMoney(price * qty);
      });

      // Update main image if variant has different image
      if (imageUrl && mainImage) {
        mainImage.src = imageUrl;
      }
    });
  }

  sellingPlanInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      document.querySelectorAll('[data-purchase-option]').forEach(function(option) {
        option.classList.toggle('is-selected', option.contains(input) && input.checked);
      });
    });
  });

  // ─────────────────────────────────────────
  // 2. Image Gallery / Thumbnails
  // ─────────────────────────────────────────
  const thumbs = document.querySelectorAll('[data-thumb-index]');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const imageUrl = this.getAttribute('data-image-url');
      const index = this.getAttribute('data-thumb-index');

      // Update main image
      if (mainImage && imageUrl) {
        mainImage.src = imageUrl;
      }

      // Update active state
      thumbs.forEach(function(t) {
        t.classList.remove('is-active');
        t.style.borderColor = 'transparent';
      });
      this.classList.add('is-active');
      this.style.borderColor = '#3A6A9A';
    });
  });

  // ─────────────────────────────────────────
  // 3. Quantity Selector
  // ─────────────────────────────────────────
  const qtyInput = document.querySelector('[data-quantity-input]');
  const qtyBtns = document.querySelectorAll('[data-qty-change]');

  function updateQuantity(change) {
    if (!qtyInput) return;
    let val = parseInt(qtyInput.value, 10) || 1;
    val = Math.max(1, Math.min(99, val + change));
    qtyInput.value = val;

    // Update add to cart button text
    const selectedOption = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
    const price = selectedOption ? parseInt(selectedOption.getAttribute('data-price'), 10) : 0;
    if (price) {
      btnTexts.forEach(function(el) {
        el.textContent = 'Add to Cart \u2014 ' + formatMoney(price * val);
      });
    }
  }

  qtyBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const change = parseInt(this.getAttribute('data-qty-change'), 10);
      updateQuantity(change);
    });
  });

  if (qtyInput) {
    qtyInput.addEventListener('change', function() {
      let val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > 99) val = 99;
      this.value = val;

      const selectedOption = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
      const price = selectedOption ? parseInt(selectedOption.getAttribute('data-price'), 10) : 0;
      if (price) {
        btnTexts.forEach(function(el) {
          el.textContent = 'Add to Cart \u2014 ' + formatMoney(price * val);
        });
      }
    });
  }

  // ─────────────────────────────────────────
  // 4. Add to Cart (AJAX via Shopify Cart API)
  // ─────────────────────────────────────────
  addToCartBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();

      const variantId = this.getAttribute('data-variant-id');
      const quantity = parseInt(qtyInput ? qtyInput.value : 1, 10);
      const sellingPlanInput = document.querySelector('[name="selling_plan"]:checked');
      const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : '';

      if (!variantId) {
        btn.classList.remove('is-loading');
        var textEl = btn.querySelector('.btn-text');
        if (textEl) textEl.textContent = 'Select a variant';
        setTimeout(function() {
          if (textEl) textEl.textContent = originalText;
        }, 2000);
        return;
      }

      // Loading state
      btn.classList.add('is-loading');
      const originalText = (btn.querySelector('.btn-text') && btn.querySelector('.btn-text').textContent) || btn.textContent;

      const payload = {
        id: parseInt(variantId, 10),
        quantity: quantity
      };
      if (sellingPlanId) {
        payload.selling_plan = parseInt(sellingPlanId, 10);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(function(data) {
        // Success state
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        const textEl = btn.querySelector('.btn-text');
        if (textEl) textEl.textContent = 'Added to Cart!';

        // Update cart count in header if it exists
        updateCartCount();

        // Revert after 2 seconds
        setTimeout(function() {
          btn.classList.remove('is-success');
          if (textEl) textEl.textContent = originalText;
        }, 2000);
      })
      .catch(function(err) {
        btn.classList.remove('is-loading');
        const textEl = btn.querySelector('.btn-text');
        if (textEl) textEl.textContent = err && err.message ? err.message : 'Error. Try again.';
        setTimeout(function() {
          if (textEl) textEl.textContent = originalText;
        }, 2000);
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const cartBadges = document.querySelectorAll('[data-cart-count]');
        cartBadges.forEach(function(badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      });
  }

  // ─────────────────────────────────────────
  // 5. FAQ Accordion (Pure JS)
  // ─────────────────────────────────────────
  const accordionItems = document.querySelectorAll('.pepax-accordion-item');

  accordionItems.forEach(function(item) {
    const trigger = item.querySelector('.pepax-accordion-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function() {
      const isOpen = item.classList.contains('is-open');

      // Close all others
      accordionItems.forEach(function(other) {
        other.classList.remove('is-open');
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  // Open first FAQ by default
  const firstFaq = document.querySelector('.pepax-accordion-item');
  if (firstFaq) {
    firstFaq.classList.add('is-open');
  }

  // ─────────────────────────────────────────
  // 6. Sticky Bar Visibility
  // ─────────────────────────────────────────
  const heroSection = document.getElementById('hero-section');
  const stickyBar = document.getElementById('sticky-bar');

  if (heroSection && stickyBar) {
    let ticking = false;

    function checkSticky() {
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        stickyBar.style.transform = 'translateY(0)';
      } else {
        stickyBar.style.transform = 'translateY(100%)';
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(checkSticky);
        ticking = true;
      }
    }, { passive: true });
  }

  // ─────────────────────────────────────────
  // 7. Scroll-triggered animation for bars
  // ─────────────────────────────────────────
  const bars = document.querySelectorAll('[data-bar-width]');

  if (bars.length > 0 && 'IntersectionObserver' in window) {
    const barObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const bar = entry.target;
          const width = bar.getAttribute('data-bar-width');
          if (width) {
            setTimeout(function() {
              bar.style.width = width + '%';
            }, 200);
          }
          barObserver.unobserve(bar);
        }
      });
    }, { threshold: 0.5 });

    bars.forEach(function(bar) {
      barObserver.observe(bar);
    });
  }

  // ─────────────────────────────────────────
  // 8. IntersectionObserver for scroll reveals
  // ─────────────────────────────────────────
  const revealElements = document.querySelectorAll('.pepax-highlight, .pepax-usage-grid > div');

  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '-40px' });

    revealElements.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.5s ease-out ' + (i * 0.12) + 's, transform 0.5s ease-out ' + (i * 0.12) + 's';
      revealObserver.observe(el);
    });
  }

})();
